/**
 * L4: the copied banner and clipboard bar (01-references §6 S8). The reference clears the
 * clipboard after 90 s. A PWA cannot (01 §3), so this bar stays up for as long as a copied value
 * may still be on the clipboard and says plainly when it will be cleared. Nothing is ever
 * invisible (Quick Search rule 3 and rule 9).
 */
import type { AppActions, AppState } from "../contract.js";
import { h, icon } from "../shell/dom.js";

export function renderClipboardBar(state: AppState, actions: AppActions): HTMLElement | null {
  if (!state.clipboard) return null;
  return h(
    "div",
    { class: "clipboard-bar", role: "status", "data-clipboard-bar": "1" },
    icon("copy"),
    h(
      "div",
      { class: "cb-text" },
      h("div", { class: "cb-title" }, `Your ${state.clipboard.label} is still on the clipboard`),
      h("div", { class: "cb-sub" }, "Vowed clears it on your next tap. Web apps on iPhone can't clear it on a timer."),
    ),
    h("button", { class: "btn-small", onclick: () => actions.clearClipboard() }, "Clear"),
  );
}

export function renderToast(state: AppState): HTMLElement | null {
  if (!state.toast) return null;
  return h("div", { class: "toast", role: "status" }, icon("check"), state.toast);
}
